import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import HospitalScheduleRegisterSubPopup from "./SubPopup/HospitalScheduleRegisterSubPopup";
import HospitalScheduleModifySubPopup from "./SubPopup/HospitalScheduleModifySubPopup";
import "./HospitalSchedulePopup.css";
import moment from "moment";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import { formatDateWbar } from "../../../../components/Util/DateFormat";
import Swal from "sweetalert2";
import axios from "axios";
import { getServerBaseUrl } from "../../../../utils/portConfig";

function HospitalSchedulePopup({ isOpen, onClose, selectedRow }) {
  const API_SERVER_URL = `${getServerBaseUrl()}/api/v1/schedule`;
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userid");

  const initialHospitalData = {
    id: "",
    hospitalId: "",
    hospitalName: "",
    hospitalAddress: "",
    hospitalTelNo: "",
    hospitalInfo: "",
  };

  const [isPopupOpen, setPopupOpen] = useState(false); //register popup
  const [isSvPopupOpen, setSvPopupOpen] = useState(false); //sv popup
  const [hospitalData, setHospitalData] = useState({ ...initialHospitalData });
  const [scheduleDate, setScheduleDate] = useState("");
  const [doctorName, setDoctorName] = useState("");
  const [currentMonth, setCurrentMonth] = useState("");
  const [dynamicEvents, setDynamicEvents] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [scheduleId, setScheduleId] = useState("");
  const [doctorId, setdoctorId] = useState("");
  const [workStatus, setWorkStatus] = useState(0);

  useEffect(() => {
    if (isOpen !== undefined) {
      setHospitalData({
        hospitalId: selectedRow ? selectedRow.hospitalId : "",
        hospitalName: selectedRow ? selectedRow.hospitalName : "",
        hospitalAddress: selectedRow ? selectedRow.hospitalAddress : "",
        hospitalTelNo: selectedRow ? selectedRow.hospitalTelNo : "",
        hospitalInfo: selectedRow ? selectedRow.hospitalInfo : "",
      });
      setDynamicEvents([]);
      if (selectedRow && currentMonth !== "") {
        getDoctorSchedule(selectedRow.id, currentMonth);
      }
    }
  }, [isOpen, selectedRow, currentMonth]);

  // 일정 등록 팝업 열기
  const handleDateClick = (eventInfo) => {
    //const isRegistable = (eventInfo.event.title === '당직' || eventInfo.event.title === '휴진' || eventInfo.event.title === '야간') && (moment(eventInfo.event.start).format('YYYY-MM-DD') >= formatDateWbar(new Date()));
    const isRegistable = moment(eventInfo.event.start).format("YYYY-MM-DD") >= formatDateWbar(new Date());
    const selectedDate = moment(eventInfo.event.start).format("YYYY-MM-DD");
    setScheduleDate(selectedDate);

    if (isRegistable) {
      setPopupOpen(true);
      setSvPopupOpen(false);
    }
  };

  const onlyDateClick = (arg) => {
    const isRegistable = formatDateWbar(new Date(arg.dateStr)) >= formatDateWbar(new Date());
    const selectedDate = formatDateWbar(new Date(arg.dateStr));
    setScheduleDate(selectedDate);

    if (isRegistable) {
      setPopupOpen(true);
      setSvPopupOpen(false);
    }
  };

  // 의사들 일정 조회
  const getDoctorSchedule = async (id, month) => {
    try {
      const response = await axios.get(`${API_SERVER_URL}/${id}/${month}/list`, { headers: { Authorization: `Bearer ${token}` } });

      if (response.status === 200) {
        setOriginalData(response.data);
        // 데이터를 가공하여 dynamicEvents에 삽입
        const updatedDynamicEvents = response.data
          .filter((item) => item.doctorName !== null)
          .map((item) => {
            let scheduleId = 0;
            let title = "";
            let doctors = [];
            switch (Number(item.type)) {
              case 0:
                title = "당직";
                doctors.push(item.doctorName);
                break;
              case 1:
                title = "휴진";
                doctors.push(item.doctorName);
                break;
              case 2:
                title = "야간";
                doctors.push(item.doctorName);
                break;
              default:
                break;
            }

            return {
              scheduleId,
              title,
              start: moment(item.schDt).format("YYYY-MM-DD"),
              extendedProps: { doctor: doctors }, // 혹은 필요한 데이터를 가져와 적절히 삽입
            };
          });

        // 같은 날짜 및 타이틀의 이벤트를 그룹화
        const groupedEvents = updatedDynamicEvents.reduce((acc, event) => {
          const existingEvent = acc.find((e) => e.start === event.start && e.title === event.title);

          if (existingEvent) {
            // 같은 날짜 및 타이틀의 이벤트가 이미 존재하면 의사 이름을 추가
            existingEvent.extendedProps.doctor.push(...event.extendedProps.doctor);
          } else {
            // 같은 날짜 및 타이틀의 이벤트가 존재하지 않으면 새로운 이벤트 추가
            acc.push({ ...event });
          }

          return acc;
        }, []);

        // dynamicEvents에 새로운 이벤트 추가
        setDynamicEvents((prevEvents) => {
          const updatedEvents = prevEvents.map((prevEvent) => {
            const matchingGroupedEvent = groupedEvents.find((groupedEvent) => groupedEvent.start === prevEvent.start && groupedEvent.title === prevEvent.title);

            if (matchingGroupedEvent) {
              // 같은 날짜 및 타이틀의 이벤트가 이미 존재하면 의사 이름을 추가
              return {
                ...prevEvent,
                extendedProps: {
                  doctor: [
                    ...(prevEvent.extendedProps?.doctor || []), // 초기값 설정
                    ...(matchingGroupedEvent.extendedProps?.doctor || []), // 초기값 설정
                  ],
                },
              };
            }
            return prevEvent;
          });

          // 새로운 이벤트가 없는 경우 기존 이벤트 반환
          return updatedEvents.length > 0 ? updatedEvents : [...prevEvents, ...groupedEvents];
        });

        setPopupOpen(false);
        setSvPopupOpen(false);
      } else {
        Swal.fire({
          icon: "error",
          title: "실패",
          text: "의사들 일정 조회 실패. 다시 시도해주세요.",
        });
      }
    } catch (error) {
      console.error("Error fetching doctor Schedule:", error);
      if (error.response) {
        const responseData = error.response.data;
        if (responseData) {
          Swal.fire({
            icon: "error",
            title: "데이터 가져오기 오류",
            text: responseData,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "서버 응답 오류",
            text: `서버 응답 오류: ${error.response.status}`,
          });
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "서버 응답이 없습니다.",
          text: "서버 응답이 없습니다.",
        });
      }
    }
  };

  // 현재 사용자가 보고있는 달 가지고오기
  const handleViewRender = (arg) => {
    const start = arg.view.currentStart;
    const currentMonth = formatDateWbar(start).match(/^\d{4}-\d{2}/)[0];
    setCurrentMonth(currentMonth);
  };

  const renderEventContent = (eventInfo) => {
    const { title, extendedProps } = eventInfo.event;

    let icons = "";
    let doctorNames = "";

    switch (title) {
      case "당직":
        icons = <span className="icon-d">{eventInfo.event.title}</span>;
        if (extendedProps?.doctor && Array.isArray(extendedProps.doctor)) {
          doctorNames = extendedProps.doctor.map((doctor, index) => (
            <div className="spot-family-container">
              <div key={index} className="doctor-names" onClick={() => handleshowViewPopup(eventInfo, doctor)}>
                {doctor}
              </div>
            </div>
          ));
        }
        break;
      case "휴진":
        icons = <span className="icon-h">{eventInfo.event.title}</span>;
        if (extendedProps?.doctor && Array.isArray(extendedProps.doctor)) {
          doctorNames = extendedProps.doctor.map((doctor, index) => (
            <div className="spot-family-container">
              <div key={index} className="doctor-names" onClick={() => handleshowViewPopup(eventInfo, doctor)}>
                {doctor}
              </div>
            </div>
          ));
        }
        break;
      case "야간":
        icons = <span className="icon-y">{eventInfo.event.title}</span>;
        if (extendedProps?.doctor && Array.isArray(extendedProps.doctor)) {
          doctorNames = extendedProps.doctor.map((doctor, index) => (
            <div className="spot-family-container">
              <div key={index} className="doctor-names" onClick={() => handleshowViewPopup(eventInfo, doctor)}>
                {doctor}
              </div>
            </div>
          ));
        }
        break;
      default:
        break;
    }

    return (
      <div className="icon-container" onClick={() => handleDateClick(eventInfo)}>
        <div className="calendar-schedule-contents">{icons}</div>
        <div className="additional-content" onClick={(e) => e.stopPropagation()}>
          {doctorNames}
        </div>
      </div>
    );
  };

  // 오늘 날짜 이전인지 확인하는 함수
  const isDateClickable = (date) => {
    const today = moment().startOf("day");
    return moment(date).isSameOrAfter(today, "day");
  };

  const handleClosePopup = () => {
    setPopupOpen(false);
    setSvPopupOpen(false);
  };

  const handleshowViewPopup = (eventInfo, doctor) => {
    setSvPopupOpen(true);
    const scheduleDate = moment(eventInfo.event.start).format("YYYY-MM-DD");
    setWorkStatus(eventInfo.event.title);
    setScheduleDate(scheduleDate);
    setDoctorName(doctor);
    originalData.find((item) => {
      if (item.schDt === scheduleDate && item.doctorName === doctor) {
        setScheduleId(item.id);
        setdoctorId(item.doctorId);
      }
    });
  };

  // 의사일정 등록하기
  const regDocSchedule = async (scheduleData) => {
    const chkDoctorExists = dynamicEvents.filter((item) => item.start === scheduleData.schDt && item.extendedProps !== undefined && item.extendedProps.doctor.includes(scheduleData.doctorName));
    if (chkDoctorExists.length === 0) {
      try {
        const response = await axios.post(`${API_SERVER_URL}/create/${userId}`, scheduleData, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (response.status === 201) {
          Swal.fire({
            icon: "success",
            title: "성공",
            text: "일정이 등록되었습니다.",
          }).then(() => {
            setPopupOpen(false);
            setDynamicEvents([]);
            getDoctorSchedule(scheduleData.hospitalId, scheduleData.stdMonth);
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "실패",
            text: "일정 등록 실패. 다시 시도해주세요.",
          });
        }
      } catch (error) {
        console.error("Doctor shchedule Create Error:", error);
        if (error.response) {
          const responseData = error.response.data;
          if (responseData) {
            Swal.fire({
              icon: "error",
              title: "일정 등록 오류",
              text: responseData,
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "서버 응답 오류",
              text: `서버 응답 오류: ${error.response.status}`,
            });
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "서버 응답이 없습니다.",
            text: "서버 응답이 없습니다.",
          });
        }
      }
    } else {
      Swal.fire("알림", "이미 해당 의사가 존재합니다.", "warning");
      return;
    }
  };

  // 의사일정 수정하기
  const modifyDocSchedule = async (modifyDocData) => {
    try {
      const response = await axios.put(`${API_SERVER_URL}/update/${userId}`, modifyDocData, { headers: { Authorization: `Bearer ${token}` } });

      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          title: "성공",
          text: "일정을 수정했습니다.",
        }).then(() => {
          setSvPopupOpen(false);
          setDynamicEvents([]);
          getDoctorSchedule(modifyDocData.hospitalId, modifyDocData.stdMonth);
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "실패",
          text: "일정 수정 실패. 다시 시도해주세요.",
        });
      }
    } catch (error) {
      console.error("Error modifying doc sched:", error);
      if (error.response) {
        const responseData = error.response.data;
        if (responseData) {
          Swal.fire({
            icon: "error",
            title: "일정 수정 오류",
            text: responseData,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "서버 응답 오류",
            text: `서버 응답 오류: ${error.respose.status}`,
          });
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "서버 응답이 없습니다.",
          text: "서버 응답이 없습니다.",
        });
      }
    }
  };

  // 의사일정 삭제하기
  const deleteDocSchedule = async (deleteData) => {
    const confirmationResult = await Swal.fire({
      icon: "question",
      title: "일정 삭제",
      text: "일정을 삭제하시겠습니까?",
      showCancelButton: true,
      confirmButtonText: "확인",
      cancelButtonText: "취소",
    });

    if (confirmationResult.isConfirmed) {
      try {
        const response = await axios.delete(`${API_SERVER_URL}/${deleteData.scheduleId}/delete`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (response.status === 204) {
          const successResult = await Swal.fire({
            icon: "success",
            title: "성공",
            text: "일정이 삭제되었습니다.",
            confirmButtonText: "확인",
          });
          if (successResult.isConfirmed) {
            setSvPopupOpen(false);
            setDynamicEvents([]);
            getDoctorSchedule(originalData[0].hospitalId, deleteData.scheduleDate.match(/^\d{4}-\d{2}/)[0]);
          }
        } else {
          await Swal.fire({
            icon: "error",
            title: "실패",
            text: "삭제 실패. 다시 시도해주세요.",
            confirmButtonText: "확인",
          });
        }
      } catch (error) {
        console.error("Error deleting doc schedule:", error);
        if (error.response) {
          const responseData = error.resonse.data;
          if (responseData) {
            Swal.fire({
              icon: "error",
              title: "일정 삭제 오류",
              text: responseData,
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "서버 응답 오류",
              text: `서버 응답 오류: ${error.response.status}`,
            });
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "서버 응답이 없습니다.",
            text: "서버 응답이 없습니다.",
          });
        }
      }
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="HospitalSchedule Popup"
      style={{
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 1000,
        },
        content: {
          position: "absolute",
          top: "50%",
          left: "53%",
          transform: "translate(-50%, -50%)",
          border: "1px solid #ccc",
          background: "white",
          borderRadius: "4px",
          width: "1100px",
          height: "680px",
        },
      }}
    >
      <div className="modal-header-close-button" onClick={onClose}>
        x
      </div>
      <div className="dashboard-content">
        {/*<div className="dashboard-content-container">*/}
        <div className="hschedule-contents">
          <FullCalendar
            plugins={[dayGridPlugin, interactionPlugin]}
            initialView="dayGridMonth"
            events={dynamicEvents}
            locale="ko"
            height="80vh"
            headerToolbar={{
              start: "prev",
              center: "title",
              end: "next",
            }}
            buttonText={{
              today: "오늘",
              month: "월",
              agendaDay: "일정",
            }}
            dayHeaderFormat={{
              weekday: "narrow",
            }}
            eventContent={renderEventContent}
            datesSet={handleViewRender}
            dateClick={onlyDateClick}
          />

          {/* 팝업 부분 */}
          {isPopupOpen && <HospitalScheduleRegisterSubPopup isOpen={isPopupOpen} onClose={handleClosePopup} onSave={regDocSchedule} scheduleDate={scheduleDate} selectedRow={selectedRow} />}
          {isSvPopupOpen && (
            <HospitalScheduleModifySubPopup
              isOpen={isSvPopupOpen}
              onClose={handleClosePopup}
              onSave={modifyDocSchedule}
              selectedRow={selectedRow}
              scheduleDate={scheduleDate}
              doctorName={doctorName}
              workStatus={workStatus}
              scheduleId={scheduleId}
              doctorId={doctorId}
              onDelete={deleteDocSchedule}
            />
          )}

          <style>
            {`
              .fc-toolbar {
                font-size: 12px;
                margin-bottom: 0;
                padding: 20px
              }

              .fc .fc-toolbar.fc-header-toolbar {
                margin-bottom: 0
              }
            `}
          </style>
        </div>
        {/*</div>*/}
      </div>
    </Modal>
  );
}

export default HospitalSchedulePopup;
